import { useChat } from '@/modules/chat/hooks';
import { useRefreshSecurityAuditSummary } from '@/modules/security-audit';
import { useFetchSettings } from '@/modules/settings/hooks';
import { useWoopra } from '@/modules/tracking';

import { ResponsiveApplication } from '../ResponsiveApplication';
import { AuthorizedAppModals } from './AuthorizedAppModals';

export const AuthorizedApplication = () => {
    useFetchSettings();

    useWoopra();
    useChat();
    useRefreshSecurityAuditSummary();

    return (
        <>
            <AuthorizedAppModals />
            <ResponsiveApplication />
        </>
    );
};
